<nav class="navbar navbar-expand-lg cus-nav-bar navbar-fixed-top flex justify-content-between fixed-nav">
    <span class="hamburger" (click)="onToggleSideNav()" *ngIf="!isSideBarOpen">
        ☰
    </span>
    <div class="hamburger" (click)="onToggleSideNav()" *ngIf="isSideBarOpen">
        X
    </div>
    <div class="cinejoyHeading">
        <span class="cine-awards-nav-header" [ngClass]="{'header_container': isArchive}"
        [routerLink]="['/cinejoy']">cinejoy</span>
    </div>
    <span class="versionSelector">
        <div class="form-floating" fxHide.xs fxHide.sm *ngIf="isArchive">
            <select class="form-select" id="floatingSelect" [(ngModel)]="version"
                aria-label="Floating label select example" (change)="onChangeVersion($event)"
                style="width: 200px;height: 55px;">
                <option *ngFor="let level of allVersions" [value]="level.id">{{level.awardsVersion}}</option>
            </select>
            <label for="floatingSelect" class="value-label">Choose Version</label>
        </div>
    </span>
</nav>
<div>
    <app-sidebar [secNavOpen]="true" [showHeader]="false" *ngIf="isSideBarOpen"></app-sidebar>
</div>

<div class="main-cotainer">
    <div [ngClass]="{ 'versionDropdwn': isArchive }">
        <div class="mt-2" fxShow.xs fxShow.sm fxHide.md fxHide.lg fxHide.xl *ngIf="isArchive">
            <div class="form-floating mb-0 m-3">
                <select class="form-select" id="floatingSelect" [(ngModel)]="version"
                    (change)="onChangeVersion($event)">
                    <option *ngFor="let level of allVersions" [value]="level.id">{{level.awardsVersion}}</option>
                </select>
                <label for="floatingSelect" class="value-label">Choose Version</label>
            </div>
        </div>

        <div class="banner mt-2">
            <div fxLayout="row wrap" fxLayout.sm="column wrap" fxLayout.md="row wrap" fxLayout.xs="column wrap"
                fxHide.xs>
                <div fxLayout="column wrap" fxFlex="50" *ngFor="let item of awardsList.awardsBanner">
                    <div class="card">
                        <div class="banner-image"
                            [ngStyle]="{'background-image': 'url(' + item.thumbnail + ')' , 'background-repeat': 'no-repeat','background-size': 'cover' }"
                            class="banner-image"></div>
                        <div>
                            <div class="award-banner-badge">
                                <img src="../../../../../assets/images/vector1.png" class="badge-image">
                                <div class="awards-text">
                                    <div class="award-name">Audience Award</div>
                                    <span class="cine-awards">cinejoy</span>
                                    <div class="award-category"> Comedy&nbsp;</div>
                                </div>
                                <img src="../../../../../assets/images/vector2.png" class="badge-image">
                            </div>
                            <div class="badge-container">
                                <div class="sub-text-award" [title]="item?.award">{{item?.award}}</div>
                                <div class="item-text-award" [title]="item?.award_message1">
                                    {{getTruncatedText(item.award_message1)}}
                                </div>
                                <div class="row">
                                    <button type="button" class="btn btn-light all-badge-btn ml-3"
                                        (click)="goToLink(item.movie_link, item.type ? item.type : null)">More
                                        Info</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="all-banners-custom-mobile mt-6 mb-2 " fxHide.lg fxHide.md>
            <div fxLayout="column" class="g-2 ml-2">
                <div fxLayout="row wrap" class="mt-3 awardess-col justify-content-center"
                    *ngFor="let item of awardsList.awardsBanner">
                    <div class="card" style="width: 95vw;display: flex;flex-direction: row;"
                        (click)="goToLink(item.movie_link, item.type ? item.type : null)">
                        <img class="card-img-top" [src]="item.mobile_thumbnail" alt="Card image cap" style="width: 130px;
                    height: 120px;
                    min-width: 130px;
                    max-width: 130px;">
                        <div class="card-body">
                            <p class="premiere" [title]="item.award">{{item.award}}</p>
                            <h5 class="premierePara" [title]="item.award_message1">
                                {{getTruncatedText(item.award_message1)}}<span *ngIf="item?.isShowReadMoreBanner"
                                    class="readmore" (click)="onClickOfDescription($event,item.award_message1)">Read
                                    More</span></h5>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="static-container">
        <div fxLayout="row" class="audiance-header">Vote now for the Audience Choice Awards!</div>
        <div fxLayout="row" fxLayout.sm="column wrap" fxLayout.md="row wrap" fxLayout.xs="column wrap">
            <div fxLayout="column wrap" fxFlex="42" fxFlex.md="33" class="audience-box">
                <div><img src="../../../../../assets/images/glasses.png"></div>
                <div class="cus-icon-label">Watch</div>
                <div class="aud-sub-text">Enjoy the latest features and films through Premieres and Showcase.</div>

            </div>
            <div fxLayout="column wrap" fxFlex="42" fxFlex.md="33" class="audience-box">
                <div><img src="../../../../../assets/images/heart.png"></div>
                <div class="cus-icon-label">Rate</div>
                <div class="aud-sub-text">Rate the features you enjoy and leave reviews for others to see.</div>
            </div>
            <div fxLayout="column wrap" fxFlex="42" fxFlex.md="33" class="audience-box">
                <div><img src="../../../../../assets/images/cup.png"></div>
                <div class="cus-icon-label">Award</div>
                <div class="aud-sub-text">Features with the best ratings will receive Audience Choice Awards.</div>

            </div>
        </div>
        <div class="row showacase-navigate">
            <button type="button" class="btn btn-light" [routerLink]="['/cinejoy/showcase']">Go to Showcase</button>

        </div>
    </div>
    <div class="recents-container">

        <div class="recents-banner" fxHide.xs>
            <div class="recent-award-header">Recent Winners</div>

            <div fxLayout="row wrap" *ngIf="awardsList?.recentWinners?.length > 0;else noWinnersTemplate">
                <div fxLayout="row wrap" fxFlex="25" fxFlex.md="25" fxFlex.sm="50"
                    *ngFor="let item of awardsList.recentWinners">
                    <div class="card award-winners-card" (click)="goToLink(item.movie_link)" style="width: 100%;">
                        <img class="card-img-top" [src]="item.thumbnail" alt="Card image cap" style="min-height: 150px;">
                        <div class="card-body">
                            <h5 class="card-title mb-0" [title]="item.winner">{{item.winner}}</h5>
                            <p class="card-text" [title]="item.award">{{getTruncatedText(item.award)}}<span
                                    *ngIf="item?.isShowReadMorewinner" class="readmore"
                                    (click)="onClickOfDescription($event,item.award)">Read More</span></p>
                            <button type="button" class="btn btn-light" style="margin-bottom: 5px;">More Info</button>

                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noWinnersTemplate>
                <p class="no-winners-message">No data available at the moment.</p>
            </ng-template>
            <div fxLayout="row wrap" class="all-awardees">
                <button type="button" class="btn btn-light all-awardees-btn" (click)="navigateAllAwards()">See all the
                    awardees</button>
            </div>
        </div>
        <div class="all-awardees-custom-mobile" fxHide.lg fxHide.md>
            <div class="row g-2 ml-2">
                <h1 class="awards-title">Recent Winners</h1>
                <ng-container *ngIf="awardsList?.recentWinners?.length > 0;else noWinnersTemplate">
                    <div class="col mt-3 awardess-col" *ngFor="let item of awardsList.recentWinners">
                        <div class="card" style="width: 95vw;display: flex;flex-direction: row;"
                            (click)="goToLink(item.movie_link)">
                            <img class="card-img-top" [src]="item.mobile_thumbnail" alt="Card image cap" style="width: 130px;
                                    height: 120px;
                                    min-width: 130px;
                                    max-width: 130px;">
                            <div class="card-body">
                                <p class="card-text" [title]="item.winner">{{item.winner}}</p>
                                <h5 class="card-title" [title]="item.award">{{getTruncatedText(item.award)}}<span
                                        *ngIf="item?.isShowReadMorewinner" class="readmore"
                                        (click)="onClickOfDescription($event,item.award)">Read More</span></h5>

                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-template #noWinnersTemplate>
                    <p class="no-winners-message">No data available at the moment.</p>
                </ng-template>
            </div>
            <div class="row all-awardees">
                <button type="button" class="btn btn-light all-awardees-btn" (click)="navigateAllAwards()">See all the
                    awardees</button>
            </div>
        </div>
    </div>
    <div class="footer-div" fxHide.xs fxHide.sm fxHide.lt-md fxFlex.md>
        <app-cinejoy-footer></app-cinejoy-footer>
    </div>

    <div class="footer-div" fxHide.lg fxHide.md fxHide.lt fxFlex.lt-md fxShow.xs fxHide.gt-lg>
        <app-cinejoy-mobile-footer></app-cinejoy-mobile-footer>
    </div>
</div>

<div class="modal fade" id="movieDescription" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true"
    #readmoremodal style="z-index: 9999999;">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <p>
                    <span [innerHTML]="descriptionDetails"></span>
                </p>
            </div>
            <div class="modal-footer">
                <button type="button" class="movie_button" data-bs-dismiss="modal">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>